import { createRequestActionTypes } from "../../../utility";

export const HeaderActionTypes = {
  get_topCategories: createRequestActionTypes('GET_TOP_CATEGORIES'),
  get_multiAccounts: createRequestActionTypes('GET_MULTI_ACCOUNTS'),
  get_customerProfile: createRequestActionTypes('GET_CUSTOMER_PROFILE'),
  get_runAsUser: createRequestActionTypes('GET_RUN_AS_USER')
}